import React from "react";
import ListViewName from "../listviews/ListViewName";
import TextFieldSearch from "../textfields/TextFieldSearch";
import SecondaryButton from "../buttons/SecondaryButton";
import Row from "../layout/Row";
import Space from "../layout/Space";
import Divider from "../layout/Divider";
import SmallSpinner from "../loading/SmallSpinner";
import DropDownGPT1 from "../dropdowns/DropDownGPT1";
import DropDownGPT0 from "../dropdowns/DropDownGTP0";
import { Spin } from "antd";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3";

function MMName({
  title,
  users,
  loading = false,
  removable,
  placeholder = "Nom",
  className = "",
  options,
  label = "",
  value = null,
  setValue,
  onAction,
  type,
  onDelete,
  icon_name,
  onSetConducteur,
  folderData,
  orgData,
}) {
  return (
    <div className={`min-h-fit ${className}`}>
      <div className="text-h2 font-semibold text-pr w-full">
        <SmallSpinner loading={loading}></SmallSpinner>{" "}
      </div>
      <Space y={10} />
      <div className="w-full h-fit">
        <DropDownGPTS3
          label={label}
          value={value}
          items={options}
          onChange={(newValue) => onAction(newValue)}
          className=" w-full"
        ></DropDownGPTS3>
        <Space x={0} />
      </div>
      <Space y={10} />
      <div className="w-full">
        {users !== null && users.length > 0 && (
          <ListViewName
            icon_name={icon_name}
            users={users}
            removable={removable}
            type={type}
            onDelete={onDelete}
            onSetConducteur={onSetConducteur}
            folderData={folderData}
            orgData={orgData}
          ></ListViewName>
        )}
      </div>
    </div>
  );
}

export default MMName;
